import { render, staticRenderFns } from "./DeptDataForm.vue?vue&type=template&id=0506da6a&scoped=true&"
import script from "./DeptDataForm.vue?vue&type=script&lang=js&"
export * from "./DeptDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506da6a",
  null
  
)

export default component.exports